// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"21917d97","99":"e61a3001","288":"02a33a6d"}[chunkId] + ".chunk.js";
};